export default class StyleUtils {
    static ellipsizeTextBox(el) {
        var wordArray = el.innerHTML.split(' ');
        while (el.scrollHeight > el.offsetHeight) {
            wordArray.pop();
            el.innerHTML = wordArray.join(' ') + '...';
        }
    }
}